import { outOfficeSlice } from 'Pages/orders_design'
import { ChannelHandler, SocketMessage, SocketMessageTypes } from 'Modules/Socket'
import { Callback } from 'Src/types/utilTypes'
import { loadersSlice, errorResponse, formErrorResponse } from 'Modules'

export class ReserveOrderChannel implements ChannelHandler {
	public constructor(private readonly dispatch: Callback) {
		this.dispatch = dispatch
	}
	public work(data: SocketMessage) {
		const { message } = data
		const type = message?.type
		const cities = message?.payload?.cities_response
		const find_by_date_range_response = message?.payload?.find_by_date_range_response
		const create_appointment_response = message?.payload?.create_appointment_response
		const status_response = message?.payload?.status_response
		const id = message?.payload?.order_id

		if (type === SocketMessageTypes.CITIES_RESPONSE && cities) {
			if (errorResponse(cities)) {
				this.dispatch(outOfficeSlice.actions.setFormError({ value: JSON.parse(cities)?.error, id }))
			} else {
				this.dispatch(outOfficeSlice.actions.setCitiesRegions(JSON.parse(cities)))
			}
		}
		if (type === SocketMessageTypes.FIND_BY_DATE_RANGE_RESPONSE && find_by_date_range_response) {
			if (errorResponse(find_by_date_range_response)) {
				this.dispatch(
					outOfficeSlice.actions.setFormError({
						value: JSON.parse(find_by_date_range_response)?.error,
						id,
					})
				)
			} else if (formErrorResponse(find_by_date_range_response)) {
				this.dispatch(
					outOfficeSlice.actions.setFormError({
						value: JSON.parse(find_by_date_range_response)?.businessErrorCode,
						id,
					})
				)
			} else {
				this.dispatch(
					outOfficeSlice.actions.setSlots({
						value: JSON.parse(find_by_date_range_response)?.slots,
						id,
					})
				)
			}
		}
		if (type === SocketMessageTypes.CREATE_APPOINTMENT_RESPONSE && create_appointment_response) {
			if (errorResponse(create_appointment_response)) {
				this.dispatch(
					outOfficeSlice.actions.setFormError({
						value: JSON.parse(create_appointment_response)?.error,
						id,
					})
				)
			} else {
				this.dispatch(
					outOfficeSlice.actions.setAppointment({ value: create_appointment_response, id })
				)
			}
			this.dispatch(loadersSlice.actions.hideGlobalLoader())
		}

		if (type === SocketMessageTypes.STATUS_RESPONSE && status_response) {
			this.dispatch(outOfficeSlice.actions.setPaperlessStatus({ value: status_response, id }))
		}
	}
}
